import useAuthenticatedAxios from "./use-authenticated-axios";
import { useCallback } from "react";
import useSWRImmutable from "swr/immutable";
import useBanks from "./use-banks";

import useAuth from "./use-auth.js";

export default function useLinxo() {
  const axios = useAuthenticatedAxios();

  async function createWidgetSession(usage, params = {}) {
    const response = await axios.post("/linxo/widget-session", {
      usage,
      ...params,
    });
    return response.data;
  }

  const finalizeConnection = useCallback(
    async (code) => {
      const response = await axios.post("/linxo/finalize-connection", { code });
      return response.data;
    },
    [axios],
  );

  return {
    createWidgetSession,
    finalizeConnection,
  };
}

export function useLinxoAccounts(
  linxoSuccess,
  linxoUsage,
  connectionCode,
  connectionId,
) {
  const { refreshBanks } = useBanks();
  const axios = useAuthenticatedAxios();
  const { userId } = useAuth();
  let payload = {
    usage: linxoUsage,
    connection_id: connectionId ?? undefined,
    code: connectionCode ?? undefined,
  };
  const {
    data: accounts,
    error,
    isLoading,
  } = useSWRImmutable(
    linxoSuccess ? [`linxo/connection`, userId] : null,
    async ([url]) => {
      const response = await axios.post(url, payload);
      await refreshBanks();
      return response.data;
    },
  );

  async function synchronizeAccounts(selectedAccountIds) {
    const res = await axios.post(
      `linxo/accounts`,
      accounts.filter((account) =>
        selectedAccountIds.includes(account.unique_id),
      ),
    );
    return res.data;
  }

  return {
    accounts: accounts || [],
    error,
    isLoading,
    synchronizeAccounts,
  };
}
